import { Chip, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { COLORS } from "constants/colors";

export default function QuestClearedChip({ isCleared }) {
  const { t, i18n } = useTranslation(["common"]);
  return isCleared ? (
    <Box sx={{ display: "flex", justifyContent: "center" }}>
      <Chip
        label={t("common:QuestClearedChip.cleared")} //"クリア済み"
        sx={{
          fontWeight: 700, // 文字の太さを指定
          color: COLORS.TEXT_BLACK, // 文字の色を指定
          backgroundColor: "white",
        }}
      />
    </Box>
  ) : (
    <Box sx={{ display: "flex", justifyContent: "center" }}>
      <Chip
        label={t("common:QuestClearedChip.uncleared")} //"未クリア"
        sx={{
          fontWeight: 700, // 文字の太さを指定
          color: COLORS.TEXT_WHITE,
          backgroundColor: "rgba(80, 80, 80, 0.5)", // 黒い透明レイヤー
        }}
      />
    </Box>
  );
}
